<template>
  <a-tooltip
    v-if="renders.length === 1"
    :title="renderTooltip(renders[0])">
    <a
      :href="renders[0].widget_url"
      target="_blank"
      rel="noopener noreferrer"
      class="revision-widgets__single">
      {{ renderName(renders[0]) }} ↗{{ renders[0].association === 'explicit' ? '' : ' ?' }}
    </a>
  </a-tooltip>
  <a-popover
    v-else-if="renders.length > 1"
    trigger="click"
    placement="bottomLeft">
    <template #content>
      <div class="revision-widgets__list">
        <a
          v-for="render in sortedRenders"
          :key="`${render.plan_id}:${render.render_type}`"
          :href="render.widget_url"
          target="_blank"
          rel="noopener noreferrer"
          class="revision-widgets__link">
          <span>{{ renderName(render) }} ↗</span>
          <span class="revision-widgets__detail">{{ completionDate(render) }}</span>
          <span
            v-if="render.association !== 'explicit'"
            class="revision-widgets__detail">
            Ревизия определена приблизительно
          </span>
        </a>
      </div>
    </template>
    <button
      type="button"
      class="revision-widgets__single">
      Виджеты · {{ renders.length }}
    </button>
  </a-popover>
</template>

<script setup>
import { computed } from 'vue';
import moment from 'moment';

const props = defineProps({ renders: { type: Array, default: () => [] } });
const sortedRenders = computed(() => [...props.renders]
  .sort((a, b) => (b.finished_at ?? '').localeCompare(a.finished_at ?? '')));
const renderName = (render) => ({ unreal: 'Анрил', gltf: 'ГЛТФ' }[render.render_type] ?? 'Виджет');
const completionDate = (render) => (render.finished_at
  ? moment(render.finished_at).format('DD.MM.YYYY HH:mm:ss') : 'Дата завершения неизвестна');
const renderTooltip = (render) => [
  renderName(render),
  completionDate(render),
  render.association === 'explicit' ? null : 'Ревизия определена приблизительно',
].filter(Boolean).join(' · ');
</script>

<style scoped>
.revision-widgets__single {
  display: inline-block;
  padding: 2px 8px;
  border: 1px solid #91caff;
  border-radius: 6px;
  background: #e6f4ff;
  color: #1677ff;
  font: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.revision-widgets__list {
  display: flex;
  flex-direction: column;
  width: 270px;
  max-width: calc(100vw - 48px);
  max-height: 300px;
  overflow-y: auto;
}

.revision-widgets__link {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 8px;
  border-radius: 4px;
}

.revision-widgets__link:hover {
  background: #f0f6ff;
}

.revision-widgets__detail {
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
}
</style>
